export const getPageNumbers = async (packagePath: string) => {
  const pageNumbersPath = packagePath + `/pageNumbers.js`;
  const data = await fetch(pageNumbersPath);

  if (!data.ok) {
    console.warn("getPageNumbers: pageNumbers.js not found (e.g. 404), using empty map.", pageNumbersPath);
    return {};
  }

  const text = await data.text();
  const prefix = "pageNumbers = ";
  if (!text.startsWith(prefix)) {
    console.warn("getPageNumbers: unexpected format (not pageNumbers = ...), using empty map.");
    return {};
  }
  const dataString = text.substring(prefix.length);

  try {
    const dataJson = JSON.parse(dataString);
    console.log("pageNumbers dataJson", dataJson);
    return dataJson;
  } catch (e) {
    console.warn("getPageNumbers: failed to parse pageNumbers.js as JSON, using empty map.", e);
    return {};
  }
};
